import { createActionGroup, emptyProps, props } from '@ngrx/store';

export enum AuthActionTypes {
  SetFromStorage = 'Set From Storage',
  Login = 'Login',
  LoginSuccess = 'Login Success',
  LoginFailure = 'Login Failure',
  ClearError = 'Clear Error',
  Logout = 'Logout',
}

export type AuthResponseType = {
  access_token: string;
}

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    [AuthActionTypes.SetFromStorage]: props<{ token: string }>(),
    [AuthActionTypes.Login]: props<{ email: string, password: string }>(),
    [AuthActionTypes.LoginSuccess]: props<{ authResponse: AuthResponseType }>(),
    [AuthActionTypes.LoginFailure]: props<{ errorMessage: string }>(),
    [AuthActionTypes.ClearError]: emptyProps(),
    [AuthActionTypes.Logout]: emptyProps(),
  }
});
